// import React from 'react';
// import SubPageHeader from '../../components/common/SubPageHeader';
// // import SubPageFooter from '../../components/common/SubPageFooter';

// // Assets Imports 
// import img1 from '../../assets/images/AnimalCopy.jpg'; 
// import img2 from '../../assets/images/TreePlantation.JPG';
// import img3 from '../../assets/images/Farms.jpg';
// import img4 from '../../assets/images/VinayOfc1.png';
// import img5 from '../../assets/images/Flute.jpg';
// import img6 from '../../assets/images/Farming2.jpg';

// const Mission = () => {
//   return (
//     <div className="bg-white min-h-screen">
      
//       {/* 1. Header Section */}
//       <SubPageHeader title="Mission & Vision" subtitle="The Global School of Happiness" />

//       <div className="container mx-auto px-6 py-20 font-serif">
//         <div className="flex flex-col lg:flex-row items-center gap-16">
          
//           {/* Left Side: Mission & Vision Text */}
//           <div className="lg:w-1/2 space-y-16 text-center lg:text-left">
            
//             {/* Mission Section */}
//             <div className="space-y-6">
//               <h2 className="text-4xl text-[#032167] tracking-[4px] uppercase border-b-2 border-[#54a50f] inline-block pb-2">
//                 Mission
//               </h2>
//               <p className="text-xl leading-relaxed text-[#555] uppercase tracking-wide font-medium">
//                 To empower every individual of the Global School of Happiness to live and let live a healthy wealthy and spiritual life.
//               </p>
//             </div>

//             {/* Vision Section */}
//             <div className="space-y-6">
//               <h2 className="text-4xl text-[#032167] tracking-[4px] uppercase border-b-2 border-[#54a50f] inline-block pb-2">
//                 Vision
//               </h2>
//               <p className="text-xl leading-relaxed text-[#555] uppercase tracking-wide font-medium">
//                 To create a society with trust and respect for nature and create win-win situations for each other by adding values to others lives.
//               </p>
//             </div>

//           </div>

//           {/* Right Side: Photo Collage (As per image_1e008c.jpg) */}
//           <div className="lg:w-1/2">
//             <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//               <div className="space-y-4">
//                 <img src={img1} alt="TGSOH Activity" className="w-full h-48 object-cover rounded shadow-lg hover:scale-105 transition-transform" />
//                 <img src={img2} alt="TGSOH Activity" className="w-full h-64 object-cover rounded shadow-lg hover:scale-105 transition-transform" />
//               </div>
//               <div className="space-y-4 pt-8">
//                 <img src={img3} alt="TGSOH Activity" className="w-full h-64 object-cover rounded shadow-lg hover:scale-105 transition-transform" />
//                 <img src={img4} alt="TGSOH Activity" className="w-full h-48 object-cover rounded shadow-lg hover:scale-105 transition-transform" />
//               </div>
//               <div className="space-y-4">
//                 <img src={img5} alt="TGSOH Activity" className="w-full h-80 object-cover rounded shadow-lg hover:scale-105 transition-transform" />
//                 <img src={img6} alt="TGSOH Activity" className="w-full h-40 object-cover rounded shadow-lg hover:scale-105 transition-transform" />
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>

//       {/* 2. Footer Section */}
//       {/* <SubPageFooter /> */}
//     </div>
//   );
// };

// export default Mission;



import React, { useEffect, useState } from 'react';
import API from '../Api';
import SubPageHeader from '../../components/common/SubPageHeader';

// Fallback Assets
import img1 from '../../assets/images/AnimalCopy.jpg'; 
import img2 from '../../assets/images/TreePlantation.JPG';
import img3 from '../../assets/images/Farms.jpg';
import img4 from '../../assets/images/VinayOfc1.png';
import img5 from '../../assets/images/Flute.jpg';
import img6 from '../../assets/images/Farming2.jpg';

const Mission = () => {
  const [data, setData] = useState({});
  const fallbacks = [img1, img2, img3, img4, img5, img6];

  // Mission.jsx मध्ये
useEffect(() => {
  const fetchMissionData = async () => {
    try {
      const res = await API.get(`get-content/${encodeURIComponent('Mission Vision')}/`);
      console.log("Backend Response:", res.data); 
      setData(res.data);
    } catch (err) {
      console.error("Error:", err);
    }
  };
  fetchMissionData();
}, []);

  const resolveImageUrl = (path, fallback) => {
    if (!path) return fallback;
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/media/${path}`;
    return `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${cleanPath}`;
  };

  return (
    <div className="bg-white min-h-screen">
      <SubPageHeader title="Mission & Vision" subtitle="The Global School of Happiness" />

      <div className="container mx-auto px-6 py-20 font-serif">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="lg:w-1/2 space-y-16 text-center lg:text-left">
            
            {/* Mission Section */}
            <div className="space-y-6">
              <h2 className="text-4xl text-[#032167] tracking-[4px] uppercase border-b-2 border-[#54a50f] inline-block pb-2">Mission</h2>
              <p className="text-xl leading-relaxed text-[#555] uppercase tracking-wide font-medium">
                {data.mission_text || "To empower every individual of the Global School of Happiness to live and let live a healthy wealthy and spiritual life."}
              </p>
            </div>

            {/* Vision Section */}
            <div className="space-y-6">
              <h2 className="text-4xl text-[#032167] tracking-[4px] uppercase border-b-2 border-[#54a50f] inline-block pb-2">Vision</h2>
              <p className="text-xl leading-relaxed text-[#555] uppercase tracking-wide font-medium">
                {data.vision_text || "To create a society with trust and respect for nature and create win-win situations for each other by adding values to others lives."}
              </p>
            </div>
          </div>

          {/* Dynamic Gallery */}
          <div className="lg:w-1/2">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className={`${i === 2 || i === 3 ? 'pt-8' : ''}`}>
                  <img 
                    
                    src={`${resolveImageUrl(data[`gallery_${i}`], fallbacks[i-1])}?t=${new Date().getTime()}`} 
                    alt="TGSOH Activity" 
                    className="w-full h-48 object-cover rounded shadow-lg hover:scale-105 transition-transform" 
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;